module.exports = __webpack_public_path__ + "7be24b1674ab0d851dfc10df6753d0af.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/aleks.jpg
// module id = 45
// module chunks = 0